import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentRegistrations = ({ members }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="bg-card rounded-xl shadow-md border border-border">
      <div className="p-6 border-b border-border">
        <h2 className="text-xl font-heading font-bold text-foreground flex items-center gap-2">
          <Icon name="Clock" size={24} color="var(--color-primary)" />
          Recent Registrations
        </h2>
      </div>

      <div className="p-6">
        {members?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="Users" size={48} className="mx-auto mb-4 text-muted-foreground" />
            <p className="text-muted-foreground">No recent registrations</p>
          </div>
        ) : (
          <div className="space-y-3 max-h-[400px] overflow-y-auto">
            {members?.map((member) => (
              <div
                key={member?.id}
                className="p-3 bg-background rounded-lg border border-border hover:border-primary/50 transition-smooth"
              >
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center overflow-hidden">
                    {member?.user_profiles?.avatar_url ? (
                      <img
                        src={member?.user_profiles?.avatar_url}
                        alt={member?.user_profiles?.full_name}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <Icon name="User" size={20} className="text-primary" />
                    )}
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-foreground text-sm">
                      {member?.user_profiles?.full_name}
                    </p>
                    <p className="text-xs text-muted-foreground">
                      {member?.user_profiles?.email}
                    </p>
                  </div>
                </div>
                <div className="flex items-center justify-between text-xs">
                  <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-primary/10 text-primary font-medium capitalize">
                    {member?.membership_plan}
                  </span>
                  <span className="text-muted-foreground">
                    {formatDate(member?.joined_at)}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentRegistrations;